module.exports = __webpack_public_path__ + "static/media/uma.598d2785.svg";